import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { cn } from "@/lib/utils";
import { Check as CheckIcon, Minus as MinusIcon } from "lucide-react";

const Indeterminate = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  {
    id?: string;
    className?: string;
    disabled?: boolean;
    checked?: boolean | "indeterminate";
    onCheckedChange?: (check: boolean) => void;
  }
>(({ className, disabled, ...props }, ref) => {
  return (
    <CheckboxPrimitive.Root
      ref={ref}
      disabled={disabled}
      className={cn(
        "ring-offset-background focus-visible:ring-ring data-[state=checked]:text-primary-foreground peer h-4 w-4 shrink-0 rounded-sm border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary hover:border-primary transition-colors duration-300",
        className
      )}
      {...props}>
      <CheckboxPrimitive.Indicator
        className={cn("flex items-center justify-center text-current")}>
        {props.checked === "indeterminate" && (
          <MinusIcon className="h-4 w-4 text-primary" />
        )}
        {props.checked === true && <CheckIcon className="h-4 w-4 text-white" />}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
});
Indeterminate.displayName = "Indeterminate";

export default Indeterminate;
